<template>
    <aside class="filter">
        <div class="filter-wrapper">
            <transition name="fade">
                <button
                    v-if="activeFilters.length"
                    @click="reset"
                    class="results-filters-reset btn btn-sm btn-outline-secondary mb-2"
                >
                    {{ $t('category.reset') }}
                </button>
            </transition>

            <slot name="menu" />

            <slot v-if="filters.length" name="filters" />
        </div>

        <div class="filter-mobile hidden-from-lg">
            <button
                @click="$store.commit('global/toggleFilters')"
                class="filter-mobile-button d-block w-100"
            >
                <spinner v-if="isLoading" size="small" />
                <template v-else>
                    <template v-if="!showFilters">
                        {{ $t('category.filters') }}
                    </template>
                    <template v-else>
                        {{ $t('category.show_amount', { amount: resultsTotal }) }}
                    </template>
                </template>
            </button>
        </div>
    </aside>
</template>

<script>
    import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
    import Spinner from '@/_vue/components/ui/spinner';

    export default {
        name: 'Filters',
        components: {
            Spinner,
        },
        props: {
            filters: {
                type: Array,
            },
            isLoading: {
                type: Boolean,
                default: false,
            },
            resultsTotal: {
                type: Number,
                default: 0,
            },
        },
        computed: {
            ...mapState('filters', {
                originalQuery: 'query',
                queryDefaults: 'queryDefaults',
            }),

            ...mapGetters('filters', [
                'activeFilters',
            ]),
        },
        methods: {
            ...mapActions('filters', [
                'getResults',
                'resetFilters',
            ]),

            ...mapMutations('filters', [
                'updateQuery',
            ]),

            cloneQuery() {
                this.query = JSON.parse(JSON.stringify(this.originalQuery));
            },

            reset() {
                this.query = this.queryDefaults;
                this.resetFilters();
                this.updateQuery(this.query);
                this.getResults();
            },
        },
        watch: {
            originalQuery: {
                handler: 'cloneQuery',
                immediate: true,
            },
        },
    };
</script>
